import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import {
  RequestPasswordResetMutation,
  RequestPasswordResetMutationMutation,
  RequestPasswordResetMutationMutationVariables,
} from "@/gql"
import ForgotPasswordForm from "../forms/ForgotPasswordForm.vue"
import useRouter from "@/router/useRouter"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const { router, routes } = useRouter()

const navigateToLogin = () => {
  router.push({ name: routes.Login })
}

const { mutate } = useMutation()
const { addSuccess } = useNotification()
const isSubmitting = ref(false)

const onSubmit = async (email: string) => {
  isSubmitting.value = true

  // Mutate
  const result = await mutate<
    RequestPasswordResetMutationMutation,
    RequestPasswordResetMutationMutationVariables
  >({
    mutation: RequestPasswordResetMutation,
    variables: {
      email,
    },
    handlePayloadErrors: true,
  })

  // Done
  if (!result?.data?.requestPasswordReset!.error) {
    addSuccess("Reset requested successfully!")
    router.push({ name: routes.ResetPassword })
  }

  isSubmitting.value = false
}

return { __sfc: true,router, routes, navigateToLogin, mutate, addSuccess, isSubmitting, onSubmit, ForgotPasswordForm }
}

})